import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaCamera, FaTimes, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const Photography = () => {
  // 示例攝影作品數據 - 您可以替換為自己的照片
  const photos = [
    
    {
      id: 1,
      src: '/images/photography/00.jpg',
      title: '街頭攝影',
      category: 'street',
      orientation: 'portrait'
    },
    {
      id: 3,
      src: '/images/photography/02.jpg',
      title: '街頭攝影',
      category: 'street',
      orientation: 'portrait'
    },
    {
      id: 4,
      src: '/images/photography/03.jpg',
      title: '人像攝影',
      category: 'portrait',
      orientation: 'portrait'
    },
    {
      id: 5,
      src: '/images/photography/04.jpg',
      title: '街頭攝影',
      category: 'street',
      orientation: 'portrait'
    },
    {
      id: 6,
      src: '/images/photography/05.jpg',
      title: '人像攝影',
      category: 'portrait',
      orientation: 'portrait'
    },
    {
      id: 7,
      src: '/images/photography/06.jpg',
      title: '人像攝影',
      category: 'portrait',
      orientation: 'portrait'
    },
    {
      id: 8,
      src: '/images/photography/08.jpg',
      title: '人像攝影',
      category: 'portrait',
      orientation: 'portrait'
    },
    {
      id: 9,
      src: '/images/photography/09.jpg',
      title: '活動記錄',
      category: 'cityscape',
      orientation: 'landscape'
    },
    {
      id: 10,
      src: '/images/photography/10.jpg',
      title: '活動記錄',
      category: 'cityscape',
      orientation: 'landscape'
    },
    {
      id: 11,
      src: '/images/photography/11.jpg',
      title: '街頭攝影',
      category: 'street',
      orientation: 'portrait'
    },
    {
      id: 12,
      src: '/images/photography/12.jpg',
      title: '人像攝影',
      category: 'portrait',
      orientation: 'portrait'
    },
    {
      id: 13,
      src: '/images/photography/13.jpg',
      title: '人像攝影',
      category: 'portrait',
      orientation: 'portrait'
    },
  ];

  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: '全部作品' },
    { id: 'cityscape', name: '活動記錄' },
    { id: 'portrait', name: '人像攝影' },
    { id: 'street', name: '街頭攝影' }
  ];

  const filteredPhotos = selectedCategory === 'all' 
    ? photos 
    : photos.filter(photo => photo.category === selectedCategory);

  const openLightbox = (photo) => {
    setSelectedPhoto(photo);
  };

  const closeLightbox = () => {
    setSelectedPhoto(null);
  };

  const navigatePhoto = (direction) => {
    const currentIndex = filteredPhotos.findIndex(photo => photo.id === selectedPhoto.id);
    let newIndex;
    
    if (direction === 'next') {
      newIndex = (currentIndex + 1) % filteredPhotos.length;
    } else {
      newIndex = currentIndex === 0 ? filteredPhotos.length - 1 : currentIndex - 1;
    }
    
    setSelectedPhoto(filteredPhotos[newIndex]);
  };

  return (
    <section id="photography" className="py-20 bg-slate-900/50 relative">
      <div className="container mx-auto px-4">
        {/* 標題區塊 */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="flex items-center justify-center mb-4">
            <FaCamera className="text-primary-500 text-4xl mr-3" />
            <h2 className="text-4xl md:text-5xl font-bold text-gradient">
              攝影作品集
            </h2>
          </div>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            透過鏡頭捕捉生活中的美好瞬間，記錄世界的多彩與感動
          </p>
        </motion.div>

        {/* 分類篩選器 */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="flex flex-wrap justify-center gap-4 mb-12"
        >
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setSelectedCategory(category.id)}
              className={`px-6 py-2 rounded-full text-sm font-medium transition-all ${
                selectedCategory === category.id
                  ? 'bg-primary-600 text-white'
                  : 'bg-white/10 text-gray-300 hover:bg-white/20'
              }`}
            >
              {category.name}
            </button>
          ))}
        </motion.div>

        {/* 照片網格 */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          {filteredPhotos.map((photo, index) => (
            <motion.div
              key={photo.id}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className={`relative group cursor-pointer overflow-hidden rounded-xl ${
                photo.orientation === 'portrait' ? 'aspect-[3/4]' : 'aspect-[4/3]'
              }`}
              onClick={() => openLightbox(photo)}
            >
              <img
                src={photo.src}
                alt={photo.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
               
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 text-white">
                  <h3 className="text-lg font-semibold mb-1">{photo.title}</h3>
                  <p className="text-sm text-gray-200">{photo.description}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>

        {/* 如果沒有照片顯示提示 */}
        {filteredPhotos.length === 0 && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="text-center py-20"
          >
            <FaCamera className="text-gray-500 text-6xl mx-auto mb-4" />
            <p className="text-gray-400 text-xl">此分類暫無作品</p>
          </motion.div>
        )}
      </div>

      {/* 燈箱效果 */}
      {selectedPhoto && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={closeLightbox}
        >
          <div className="relative max-w-6xl max-h-full">
            {/* 關閉按鈕 */}
            <button
              className="absolute top-4 right-4 text-white text-2xl hover:text-primary-400 z-10"
              onClick={closeLightbox}
            >
              <FaTimes />
            </button>

            {/* 上一張按鈕 */}
            <button
              className="absolute left-4 top-1/2 transform -translate-y-1/2 text-white text-2xl hover:text-primary-400 z-10"
              onClick={(e) => {
                e.stopPropagation();
                navigatePhoto('prev');
              }}
            >
              <FaChevronLeft />
            </button>

            {/* 下一張按鈕 */}
            <button
              className="absolute right-4 top-1/2 transform -translate-y-1/2 text-white text-2xl hover:text-primary-400 z-10"
              onClick={(e) => {
                e.stopPropagation();
                navigatePhoto('next');
              }}
            >
              <FaChevronRight />
            </button>

            {/* 圖片 */}
            <motion.img
              key={selectedPhoto.id}
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              src={selectedPhoto.src}
              alt={selectedPhoto.title}
              className="max-w-full max-h-full object-contain"
              onClick={(e) => e.stopPropagation()}
              
            />

            {/* 圖片資訊 */}
            <motion.div
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              className="absolute bottom-4 left-4 text-white"
              onClick={(e) => e.stopPropagation()}
            >
              <h3 className="text-xl font-semibold mb-1">{selectedPhoto.title}</h3>
              <p className="text-gray-200">{selectedPhoto.description}</p>
            </motion.div>
          </div>
        </motion.div>
      )}
    </section>
  );
};

export default Photography;